/* Polsk katalog for locale-invoice-detail-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'inv.pay.originalAmount': 'Kwota w {currency}',
  'inv.pay.bankAmountCurrency': 'Kwota bankowa w {currency}',
  'inv.pay.fxPreview': 'Należność zostanie rozliczona kwotą {receivable} {accountingCurrency}. Różnica względem kwoty bankowej zostanie zaksięgowana jako {kind}: {difference}.',
  'inv.pay.fxGain': 'dodatnia różnica kursowa',
  'inv.pay.fxLoss': 'ujemna różnica kursowa',
});
